'use strict';

module.exports = (element, index) => true;